import type { PolicyLink } from '../services/types'

/**
 * sessionStorage list written by {@link Dashboard} after getPolicies; shape must stay aligned.
 * Used to hydrate claim screens without a second list fetch when the user has only ?policyRef in the URL.
 */
export const POLICIES_LIST_CACHE_KEY = 'club4x4_policies_cache'

type CachedListShape = { policies: PolicyLink[]; firstName?: string }

/**
 * Read a single policy from the dashboard policies list cache (if present and still valid JSON).
 */
export function readPolicyFromListCache(policyRef: string | null | undefined): PolicyLink | null {
  if (!policyRef) return null
  try {
    const raw = sessionStorage.getItem(POLICIES_LIST_CACHE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as CachedListShape
    if (!parsed.policies || !Array.isArray(parsed.policies)) return null
    const found = parsed.policies.find((p) => p.policyRef === policyRef) as PolicyLink | undefined
    return found ?? null
  } catch {
    return null
  }
}
